module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAA4klEQVQ4T62TXYqDMBSFT1biAhRFFBFERBFxvT4Jioi/iIg+uhnJkA690HY65ULzlpzzkfsrruuSZVlC0zTouo5PRxRFIc/zhBACeZ7DMIx/GdH3vZzn+WZSUJZlME3zLSSklHIcR0zTRCYFWZb1J3QDlKJ+GYaBTGmawrbtF4gApSzLgq7ryJQkCRzHeYAeAKWs64q2bckUxzFc16X7C6CUbdvQNA2ZoiiC53m/hbnn8Bzsvu+o65qewzCE7/vvAeU8jgNVVREUBMEXAVZIrKRZZWU1jjUarOFjjzd7gbgr+gOpj7Rp9JG9fAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right@2x.png
// module id = 56Ko
// module chunks = 1